import React, { useEffect, useRef, useState } from "react";

import { Dropdown, GenericTable, Input, toastMessage, Button, tCell, ActionMenu, Dialog, ConfirmationDialog } from "../utils/index";
import { buttonClasses } from "../utils/theme";
import { useCheckpoints, useOrgs, usePlant, useProductCategories, useProducts, useUserDetail, useUserPermissions, useUsers } from "../../services/hooks";
import { fakeFileInput, formatDate, isObjectEqual } from "../../services/functions";
import { useAddProductMutation, useDeleteProductMutation, useUpdateProductMutation, useUploadBulkProductMutation } from "../../api/vmsSlice";
import { useGetWorkflowListMutation } from "../../api/vmsSlice";
import { Navigate } from "react-router-dom/dist";
import { useUploadExcelMutation } from "../../api/api";
import Genericfilter from "../utils/Genericfilter";
import { debounce } from "../../services/functions";
import { Grid } from "@mui/material";
import { GenericstatsV2 } from "../utils/Genericstats";
import CommonTour, { TourIcon } from "../Tour/CommonTour";
import { usePlantContext } from "../../context/plantContext";
const dummyTourData = [
	{
		_id: "67fe40d11a54c181c24cc5f6",
		productName: "Meals on Wheels",
		perDayTarget: "150",
		priority: 1,
		productId: "000",
		prefix: "",
		productCategory: "Organic Matter",
		productCategoryId: "67fe40a51a54c181c24cc5c9",
		orgId: "65af5e42b41c7ab7ed1119ff",
		orgName: "LVMH",
		workFlowId: "67fe40661a54c181c24cc5aa",
		checkpoints: [],
		users: [],
		created_by: {
			user_id: "632c5cd8a62a978fd33d4b8c",
			user_type: "superAdmin",
			name: "Shubham",
			email: "shubham.a@lynkit.in",
		},
		created_on: "2025-04-15T11:19:45.964Z",
		modified_by: {
			user_id: "632c5cd8a62a978fd33d4b8c",
			user_type: "superAdmin",
			name: "Shubham",
			email: "shubham.a@lynkit.in",
		},
		modified_on: "2025-04-15T11:19:45.964Z",
		__v: 0,
	},
];
const ProductManagementTour = [
	{
		target: ".title",
		content: "Welcome to Product Management! Here you can manage all your products and their configurations.",
		placement: "bottom",
	},
	{
		target: ".genericStats-containter",
		content: "These cards provide an overview of your product statistics at a glance.",
		placement: "bottom",
	},
	{
		target: "#Genericfilter",
		content: "Filter products by name or category to find specific entries quickly.",
		placement: "bottom",
	},
	{
		target: ".addProduct",
		content: "Create new products individually using this button.",
		placement: "left",
		condition: () => !!document.querySelector('[aria-label="Add Product"]'),
	},
	{
		target: ".bulkUpload",
		content: "Upload multiple products at once using an Excel template.",
		placement: "left",
		condition: () => !!document.querySelector('[aria-label="Bulk Upload"]'),
	},
	{
		target: ".downloadSample",
		content: "Download the Excel template to ensure proper formatting for bulk uploads.",
		placement: "left",
		condition: () => !!document.querySelector('[aria-label="Download Sample"]'),
	},
	{
		target: ".main_content",
		content: "This table lists all your products with their categories, priorities, and targets.",
		placement: "top",
	},
	{
		target: ".actionMenu",
		content: "Edit existing products or manage their configurations using these action buttons.",
		placement: "left",
		condition: () => !!document.querySelector(".ActionMenu"),
	},
];
const SAMPLE_EXCEL_PATH = "/sample_excels/prod_sample.xlsx";
const EXCEL_TYPE = "product";

const defaultFilter = {
	pagesize: 10,
	page_no: 1,
};

const Product = () => {
	const { userPermissions, isFetched } = useUserPermissions();

	const { userDetail } = useUserDetail();
	const { plantId } = usePlantContext();
	const shouldHandlePlant = userDetail?.userType == "superAdmin" || userPermissions?.managePlant?.value;
	const tourRef = useRef();
	const [isTourMode, setIsTourMode] = useState(false);
	const shouldRunTour = !userDetail?.moduleTour?.products;
	const { orgOptions } = useOrgs();
	const { plantOptions, getPlantDetails, clearPlants } = usePlant();
	useEffect(() => {
		if (userPermissions?.managePlant?.value) {
			getPlantDetails({});
		}
	}, [userPermissions]);

	const [isModal, setIsModal] = useState(false);
	const [fetchStats, setFetchStats] = useState(false);
	const onModalClose = () => {
		setIsModal(false);
		if (updateDataRef.current) {
			updateDataRef.current = null;
		}
	};
	const onModalOpen = () => setIsModal(true);
	const updateDataRef = useRef(null);
	const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
	const [productToDelete, setProductToDelete] = useState(null);
	const filterFields = [
		{
			inputType: "textfield",
			id: "1",
			name: "productName",
			type: "text",
			label: "Product Name",
			placeholder: "ProductName",
		},
		{
			inputType: "textfield",
			id: "2",
			name: "productCategory",
			type: "text",
			label: "Categories",
			placeholder: "Categories",
		},
	];
	if (userDetail?.userType == "superAdmin") {
		filterFields.push({
			inputType: "dropdown",
			id: "orgId",
			name: "orgId",
			label: "Organization",
			error: "",
			option: orgOptions,
		});
	}
	if (shouldHandlePlant && userDetail?.userType == "superAdmin") {
		filterFields.push({
			inputType: "dropdown",
			id: "plantIds",
			name: "plantIds",
			label: "Warehouse",
			error: "",
			option: plantOptions,
		});
	}

	const filterRef = useRef(defaultFilter);
	if (userDetail.userType !== "superAdmin") {
		filterRef.current.plantIds = plantId;
	}
	const { page_no = 1, pagesize = 10 } = filterRef.current;

	const { products, count, isLoading, getProducts } = useProducts(userDetail.userType === "superAdmin" ? filterRef.current : null);
	useEffect(() => {
		if (filterRef.current && userDetail?.userType !== "superAdmin") {
			getProducts(filterRef.current);
		}
	}, [plantId]);
	const [handleDelete] = useDeleteProductMutation();

	let actionHandlers = {};
	if (userPermissions?.updateProduct?.value) {
		actionHandlers.edit = (id) => {
			updateDataRef.current = products[id];
			setIsModal(true);
		};
	}
	if (userPermissions?.deleteProduct?.value) {
		actionHandlers.delete = async (id) => {
			// console.log(id, "delete");
			// const data = products[id];
			// const payload = { deleteId: data._id };
			// const {
			// 	data: { error, message },
			// } = await handleDelete(payload);
			// if (error) {
			// 	toastMessage(false, message);
			// } else {
			// 	onUpdateSuccess();
			// 	toastMessage(true, message);
			// }
			setDeleteConfirmOpen(true);
			setProductToDelete(products[id]);
		};
	}
	const handleDeleteConfirm = async () => {
		if (!productToDelete) return;

		const payload = { deleteId: productToDelete._id };
		const {
			data: { error, message },
		} = await handleDelete(payload);

		if (error) {
			toastMessage(false, message);
		} else {
			onUpdateSuccess();
			toastMessage(true, message);
		}

		setDeleteConfirmOpen(false);
		setProductToDelete(null);
	};

	const handleDeleteCancel = () => {
		setDeleteConfirmOpen(false);
		setProductToDelete(null);
	};

	let header = ["S.no", "Product Name", "Product Category", "Priority", "Per Day Target"];

	if (userDetail?.userType == "superAdmin") {
		header.push("Org Name");
	}
	if (userPermissions?.updateProduct?.value || userPermissions?.deleteProduct?.value) {
		header.push("Action");
	}

	const rows =
		(shouldRunTour || isTourMode ? dummyTourData : products)?.map((d, i) => {
			let row = [];
			row.push(tCell((page_no - 1) * pagesize + i + 1), tCell(d.productName), tCell(d.productCategory), tCell(d.priority), tCell(d.perDayTarget));

			if (userDetail?.userType == "superAdmin") {
				row.push(tCell(d.orgName));
			}
			// if permission
			if (userPermissions?.updateProduct?.value || userPermissions?.deleteProduct?.value) {
				row.push(
					<div style={{ paddingLeft: "0.5rem" }}>
						<ActionMenu id={i} handlers={actionHandlers} />
					</div>
				);
			}
			return row;
		}) || [];

	const onPageChange = (page_no) => {
		filterRef.current = { ...filterRef.current, page_no: page_no + 1 };
		getProducts(filterRef.current);
	};
	const onPageSizeChange = (e) => {
		const { value } = e.target;
		filterRef.current = { ...filterRef.current, pagesize: value };
		getProducts(filterRef.current);
	};
	const onUpdateSuccess = () => {
		getProducts(filterRef.current);
		setFetchStats((old) => !old);
	};

	const [handleUploadExcel] = useUploadBulkProductMutation();
	const onBulkExcelUpload = () => {
		fakeFileInput(async (formData) => {
			formData.append("type", EXCEL_TYPE);
			// const payload = {
			// 	file,
			// 	type: EXCEL_TYPE,
			// };
			const {
				data: { error, message },
			} = await handleUploadExcel(formData);
			if (error) {
				toastMessage(false, message);
			} else {
				toastMessage(true, message);
				onUpdateSuccess();
			}
		});
	};
	/**
	 * We use GenericFilter component for all CRUD filters. That component maintains its own state for the filter
	 * and that object is sent here to the handleFilterChange function.
	 * Mutating this _filter object will cause the filter state to change on rerender (It's probably because of object reference in JS. The filter object from the state gets mutated and then the component gets re-rendered  due to any reason and now the state will have the mutated object)
	 * Here we have relationship between Org and Plant. On selecting an org, we will fetch its plant. So in order to clear previous selected plant when selecting different org, we will mutate the _filter object
	 */

	const handleFilterChange = (_filter) => {
		let filter = { ..._filter };

		for (let key in filter) {
			if (!filter[key]) delete filter[key];
		}
		if (userDetail.userType == "superAdmin") {
			if (filter.orgId) {
				// filter.orgId = filter.orgId?.value;
				if (shouldHandlePlant && filter.orgId != filterRef.current.orgId) {
					// when switching organization, we want to
					// - get plants for that org
					// - clear plantIds from the local filter object
					// - clear plantIds from original filter object, mutating the state and clearing the plant dropdown
					delete filter.plantIds;
					delete _filter.plantIds;
					getPlantDetails({ orgId: filter.orgId });
				}
			} else {
				clearPlants();
			}
		}
		// if (filter.plantIds) filter.plantIds = filter.plantIds?.value;

		filter.page_no = 1;
		filter.pagesize = 10;
		if (!isObjectEqual(filterRef.current, filter)) {
			filterRef.current = { ...filter };
			getProducts(filterRef.current);
		}
		// getProducts(filterRef.current);
	};

	const handleTourStart = () => {
		setIsTourMode(true);
		tourRef.current?.restartTour();
	};
	if (isFetched && userPermissions && Object.keys(userPermissions).length && !userPermissions.getProduct?.value) return <Navigate to="/not-authorized" replace />;

	return (
		<div className="contentpanel">
			<CommonTour ref={tourRef} steps={ProductManagementTour} moduleName="products" onTourComplete={() => setIsTourMode(false)} />
			<Grid container spacing="0.5rem">
				<Grid item xl={6} lg={6} md={5} sm={12} xs={12}>
					<h1 className="title">
						Product
						<span title="Replay Tour" onClick={handleTourStart} style={{ cursor: "pointer" }}>
							<TourIcon />
						</span>
					</h1>
				</Grid>
				<Grid item xl={6} lg={6} md={7} sm={12} xs={12}>
					<Grid container spacing="0.5rem">
						{userPermissions?.addProduct?.value ? (
							<Grid item xl={4} lg={4} md={4} sm={4} xs={12} className="addProduct">
								<Button onClick={onModalOpen} text="Add Product" style={buttonClasses.lynkitOrangeEmpty} />
							</Grid>
						) : null}
						{userPermissions?.addProduct?.value ? (
							<Grid item xl={4} lg={4} md={4} sm={4} xs={12} className="bulkUpload">
								<Button onClick={onBulkExcelUpload} text="Bulk Upload" style={buttonClasses.lynkitOrangeFill} />
							</Grid>
						) : null}
						{userPermissions?.addProduct?.value ? (
							<Grid item xl={4} lg={4} md={4} sm={4} xs={12} className="downloadSample">
								<a href={SAMPLE_EXCEL_PATH} download>
									<Button text="Download Sample" style={buttonClasses.lynkitBlackFill} />
								</a>
							</Grid>
						) : null}
					</Grid>
				</Grid>
			</Grid>

			<hr className="bgg" />
			<GenericstatsV2 statsFor={"product"} fetchStats={fetchStats} plantId={plantId} />
			<Genericfilter filterFields={filterFields} onFilterChange={debounce((filter) => handleFilterChange(filter), 500)} addOnClear />
			<div className="main_content">
				<GenericTable header={header} rows={rows} pageCount={count} pageNo={page_no} limit={pagesize} onPageChange={onPageChange} onPageSizeChange={onPageSizeChange} isLoading={isLoading} />
			</div>

			{isModal && <AddProduct open={isModal} onClose={onModalClose} updateData={updateDataRef.current} onUpdateSuccess={onUpdateSuccess} />}
			<ConfirmationDialog open={deleteConfirmOpen} handleClose={handleDeleteCancel} handleSubmit={handleDeleteConfirm} title="Delete Product" submitText="Delete">
				Are you sure you want to delete this product? This action cannot be undone.
			</ConfirmationDialog>
		</div>
	);
};

export default Product;

const defaultForm = {
	productName: "", // required
	updateId: undefined, // for update case
	productCategoryId: "", // required
	perDayTarget: "",
	priority: "",
	orgId: undefined,
	plantId: "",
	checkpoints: [],
	users: [],
	// approvalId: "",
	prefix: "",
	productId: "",
	// description: "Base fruit to be distilled",
};

function fillUpdateData(data) {
	return {
		productName: data.productName,
		updateId: data._id,
		productCategoryId: data.productCategoryId,
		perDayTarget: data.perDayTarget,
		priority: data.priority,
		orgId: data.orgId,
		plantId: data.plantId,
		checkpoints: data.checkpoints || [],
		users: data.users || [],
		workFlowId: data.workFlowId || "",
		// approvalId: data.approvalId || "",
		prefix: data.prefix || "",
		productId: data.productId || "",
	};
}

function AddProduct({ onClose, open, updateData, onUpdateSuccess }) {
	const [formData, setFormData] = useState(updateData ? fillUpdateData(updateData) : defaultForm);
	const [error, setError] = useState({});
	const [workflowListing, setWorkFlowListing] = useState([]);
	const { userDetail } = useUserDetail();
	const { userPermissions } = useUserPermissions();
	const shouldHandlePlant = userDetail?.userType == "superAdmin" || userPermissions?.managePlant?.value;
	const { orgOptions } = useOrgs();
	const orgValue = orgOptions.find((_) => _.value == formData.orgId);
	const { plantOptions, clearPlants, getPlantDetails } = usePlant();
	const plantValue = plantOptions.find((opt) => opt.value === formData.plantId);
	const { plantId } = usePlantContext();
	useEffect(() => {
		getPlantDetails({ orgId: formData.orgId || userDetail?.orgId });
	}, [formData.orgId]);
	// const { userOptions, getUsers } = useUsers();
	// let userValues = userOptions?.filter((chk) => formData.users?.find((fchk) => fchk == chk.value));
	// console.log(userValues, formData.users);
	const filterRef = useRef({ type: "bay" });
	const { checkpointOptions, getCheckpoints } = useCheckpoints({ plantIds: formData?.plantId || plantId, type: "bay" }, "bayCheckpoint" );  // sending this ficedCache key to avoid the rerendering of the sidebar checkpoint listing.
	let checkpointValues = checkpointOptions?.filter((chk) => formData.checkpoints?.find((fchk) => fchk == chk.value));

	const { options: productCategoryOptions, getProdCats } = useProductCategories();
	const productCategoryValue = productCategoryOptions.find((_) => _.value == formData.productCategoryId);

	const [getWorkflowListTrigger, { isLoading }] = useGetWorkflowListMutation();

	const handleInput = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};
	const onDropdownChange = (option, name) => {
		let value = Array.isArray(option) ? option.map((_) => _.value) : option?.value || "";
		handleInput({ target: { name, value } });

		if (name == "orgId" && shouldHandlePlant) {
			if (value) {
				getPlantDetails({ orgId: value });
				getCheckpoints({orgId: value, type:"bay"})
			} else {
				clearPlants();
			}
		}
	};

	function fetchByPlantId(plantId) {
		// getUsers({ orgId });
		getProdCats({ plantIds: plantId });
		filterRef.current = { ...filterRef.current, plantIds: plantId };
		getCheckpoints(filterRef.current)
	}
	const fetchWorkFlowListing = (payload = {}) => {
		getWorkflowListTrigger(payload)
			.unwrap()
			.then((res) => {
				// console.log('res==', res)
				if (res?.data) {
					const option = res.data.map((_) => ({ label: _.name, value: _._id }));
					setWorkFlowListing(option);
					// setCount(res.count)
					// setFilter((previousValue) => ({ ...previousValue, count: res.count }));
				}
				if (res.error == true) {
					// toastMessage(false, res.message);
					setWorkFlowListing([]);
				}
			})
			.catch((err) => {
				// toastMessage(false, err.message);
				setWorkFlowListing([]);
			});
	};

	// const [getApprovalConfigsTrigger] = useGetApprovalConfigMutation({});
	// const [approvalConfigOptions, setApprovalConfigOptions] = useState([]);

	// const fetchApprovalConfigurations = (payload = {}) => {
	// 	getApprovalConfigsTrigger(payload)
	// 		.unwrap()
	// 		.then((res) => {
	// 			if (res.data) {
	// 				const options = res.data.map((_) => ({ label: _.module, value: _._id }));
	// 				setApprovalConfigOptions(options);
	// 			} else {
	// 				setApprovalConfigOptions([]);
	// 			}
	// 		})
	// 		.catch((err) => setApprovalConfigOptions([]));
	// };

	useEffect(() => {
		// console.log("hey");
		fetchByPlantId(formData.plantId || plantId);
		fetchWorkFlowListing(formData.plantId ? { plantIds: formData.plantId } : { plantIds: plantId });
		// fetchApprovalConfigurations(formData.orgId ? { orgId: formData.orgId } : {});
	}, [formData.plantId]);
	useEffect(() => {
		getPlantDetails({ orgId: formData.orgId || userDetail?.orgId });
	}, [formData.orgId]);
	const [handleAdd, { isLoading: isAdding }] = useAddProductMutation();
	const [handleUpdate, { isLoading: isUpdating }] = useUpdateProductMutation();

	const handleFormSubmit = async () => {
		const payload = { ...formData, orgName: orgValue?.label, plantId: userDetail?.userType === "superAdmin" ? formData.plantId : plantId };
		// console.log(payload);
		const {
			data: { error, message },
		} = updateData ? await handleUpdate(payload) : await handleAdd(payload);
		if (error) {
			toastMessage(false, message);
		} else {
			toastMessage(true, message);
			onUpdateSuccess();
			handleClose();
		}
	};

	const handleFormValidation = () => {
		let error = {};
		if (userDetail?.userType == "superAdmin" && !formData.orgId) error.orgId = "Organization name is required";
		if (shouldHandlePlant && !formData.plantId.length && userDetail?.userType == "superAdmin") error.plantId = "Warehouse is required";
		if (!formData.productCategoryId) error.productCategoryId = "Product Category is required";
		if (!formData.productName) error.productName = "Product Name is required";
		if (!formData.priority) error.priority = "Priority is required";
		if (!formData.perDayTarget) error.perDayTarget = "Per Day Target is required";
		// if (!formData.workFlowId) error.workFlowId = "Workflow is required";

		if (Object.keys(error).length) {
			setError(error);
		} else {
			handleFormSubmit();
		}
	};
	const handleClose = () => {
		setFormData(defaultForm);
		setError({});
		onClose();
	};
	return (
		<Dialog size="sm" open={open} handleClose={handleClose} handleSubmit={handleFormValidation} title={updateData ? "Update Product" : "Add Product"} isSubmitDisabled={isAdding || isUpdating}>
			<form className="form-inputs">
				{userDetail?.userType == "superAdmin" ? (
					<Dropdown id="orgId" name="orgId" label="Organization Name" onChange={onDropdownChange} options={orgOptions} value={orgValue} error={error.orgId} required />
				) : null}
				{shouldHandlePlant && userDetail?.userType == "superAdmin" ? (
					<Dropdown id="plantIdAdd" name="plantId" label="Warehouse" onChange={onDropdownChange} options={plantOptions} value={plantValue} required error={error.plantId} />
				) : null}
				{/* <Dropdown id="users" name="users" label="Users" onChange={onDropdownChange} options={userOptions} value={userValues} required multiple error={error.users} /> */}
				<Dropdown
					id="checkpoints"
					name="checkpoints"
					label="Bay Checkpoints"
					onChange={onDropdownChange}
					options={checkpointOptions}
					value={checkpointValues}
					multiple
					error={error.checkpoints}
				/>
				<Dropdown
					id="productCategoryId"
					name="productCategoryId"
					label="Product Category"
					onChange={onDropdownChange}
					options={productCategoryOptions}
					value={productCategoryValue}
					required
					error={error.productCategoryId}
				/>
				<Input label="Product Name" placeholder="Enter Product Name" name="productName" value={formData.productName} onChange={handleInput} required error={error.productName} />
				<Input label="Priority" placeholder="Enter Priority" name="priority" value={formData.priority} onChange={handleInput} required error={error.priority} />
				<Input label="Per Day Target" placeholder="Enter Per Day Target" name="perDayTarget" value={formData.perDayTarget} onChange={handleInput} error={error.perDayTarget} required />
				<Dropdown
					id="workFlowId"
					name="workFlowId"
					label="WorkFlow"
					onChange={onDropdownChange}
					options={workflowListing}
					value={formData?.workFlowId ? workflowListing.filter((ele) => ele.value === formData.workFlowId)[0] : null}
					// error={error.workFlowId}
					// (workflowListing.filter((ele)=> ele.id === formData.workFlowId))[0]
					// required
					// error={error.productCategoryId}
				/>
				{/* <Dropdown
					id={"approvalId"}
					name={"approvalId"}
					value={formData.approvalId ? approvalConfigOptions.find((ele) => ele.value == formData.approvalId) : null}
					options={approvalConfigOptions}
					label={"Approval Configuration"}
					onChange={onDropdownChange}
				/> */}
				<Input label="Prefix" placeholder="Enter Prefix" name="prefix" value={formData.prefix} onChange={handleInput} />
				<Input label="Product Id" placeholder="Enter Product Id" name="productId" value={formData.productId} onChange={handleInput} />
			</form>
		</Dialog>
	);
}
